"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var generic_1 = require("../generic");
var HeadersDetail = function (props) {
    var sorted = null;
    if (props.header.sorted) {
        if (props.header.direction.toLowerCase() == 'asc') {
            sorted = (React.createElement(generic_1.Icon, { name: generic_1.Icons.sort_descending, className: "ml-1" }));
        }
        else {
            sorted = (React.createElement(generic_1.Icon, { name: generic_1.Icons.sort_ascending, className: "ml-1" }));
        }
    }
    return (React.createElement("th", { className: props.column.get_header_class() }, props.header.url ?
        React.createElement(React.Fragment, null,
            React.createElement("a", { onClick: props.click, href: props.header.url }, props.header.label),
            sorted && (React.createElement("a", { onClick: props.click, href: props.header.url }, sorted)))
        :
            props.header.label));
};
exports.default = HeadersDetail;
